import { render } from "./RegistrationRequestPanel.vue?vue&type=template&id=3efb8642"
import script from "./RegistrationRequestPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationRequestPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script